import ProductIdentifier from '@ingka/product-identifier';
import { Currency } from '@onlinepayments/payments-library';
import * as Sentry from '@sentry/browser';

import OrderListItemImage from '../../../../components/OrderItemList/OrderListItemImage';
import { OrderItem } from '../../../../interfaces/Order';
import { formatArticleNo } from '../../../../utils/immutability-utils';

type OrderSummaryModalItemProps = {
  item: OrderItem;
  currency: string;
};

export const OrderSummaryModalItem = ({
  item: { salesItem, orderLine },
  currency,
}: OrderSummaryModalItemProps) => {
  const {
    itemKey: { itemNo },
    localisedCommunications,
  } = salesItem;
  const { quantity, amount } = orderLine;

  if (!localisedCommunications?.length) {
    Sentry.captureMessage(`Missing localisedCommunications for sales item ${itemNo}.`, 'error');
    return null;
  }

  const [{ productName, validDesign, measurements }] = localisedCommunications;
  const dimensions = measurements?.referenceMeasurements?.[0]?.metric;
  const descriptionParts = [validDesign?.text, dimensions].filter(Boolean);

  return (
    <li className="OrderSummaryModalItem" key={itemNo}>
      <div className="OrderSummaryModalItem__left">
        <OrderListItemImage item={salesItem} />
        <ProductIdentifier value={formatArticleNo(itemNo)} subtle />
      </div>
      <div className="OrderSummaryModalItem__right">
        <div className="OrderSummaryModalItem__row">
          <h3 className="OrderSummaryModalItem__name">
            {quantity ? `${quantity}x ` : ''}
            {productName}
          </h3>
          {amount !== undefined && amount !== null && (
            <span className="OrderSummaryModalItem__price">
              <Currency currency={currency} amount={amount} />
            </span>
          )}
        </div>
        {descriptionParts.length > 0 && (
          <p className="OrderSummaryModalItem__description">{descriptionParts.join(', ')}</p>
        )}
      </div>
    </li>
  );
};
